import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SchoolService {

  constructor(private http: HttpClient) { }

  configUrl:string;


  getContent(theSchool, thePage){
  	let content = thePage ? thePage : "";
    // this.configUrl = "http://localhost/apigbu/school/"+theSchool+"/"+content;
  	this.configUrl = "http://api.thegbu.in/school/"+theSchool+"/"+content;
  	return this.http.get(this.configUrl);
  }




  getConfig(){
  	return this.http.get(this.configUrl, {responseType: "text"});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/school.service.ts